export default __webpack_public_path__ + "static/media/expand-2.d05b94a3.svg";